module.exports = __webpack_public_path__ + "img/lpr_night_down_selected.c8fa2222.svg";